<div class="form-horizontal" [formGroup]="experimentDesignFormGroup">
  <div class="form-group" [class.has-error]="pesticidesAllowed.invalid">
    <label class="control-label col-sm-2">Pesticides Allowed</label>
    <span class="col-sm-3">
      <select formControlName="pesticidesAllowed" class="form-control">
        <option [ngValue]="null"></option>
        <option *ngFor="let option of plantHandlingOptions.pesticideInstructions" [ngValue]="option.id">
          {{ option.display }}
        </option>
      </select>
    </span>
  </div>

  <div class="form-group" *ngIf="requiresNumberOfDays()" [class.has-error]="pesticideLifeOfPlant.invalid">
    <label class="col-sm-3 control-label">Duration:</label>
    <div class="col-sm-6 col-sm-offset-0">
      <div class="radio">
        <label>
          <input type="radio" formControlName="pesticideLifeOfPlant" [value]="true"
            [required]="requiresNumberOfDays()" />
          Life of plant
        </label>
      </div>
      <div class="radio">
        <label>
          <input type="radio" style="margin-top: 17px" formControlName="pesticideLifeOfPlant" [value]="false"
            [required]="requiresNumberOfDays()" />
          Resume standard pesticide application
          <input type="number" class="form-control" formControlName="pesticidesAllowedAfterDays" min="1" [required]="
              pesticideLifeOfPlant.value === false && requiresNumberOfDays()
            " [disabled]="pesticideLifeOfPlant.value !== false"
            style="width: 80px; display: inline-block; margin: 6px" />
          days after planting
        </label>
        <div class="alert alert-danger" *ngIf="pesticidesAllowedAfterDays.errors?.min">
          Number of days must be at least
          {{ pesticidesAllowedAfterDays.errors.min.min }}
        </div>
        <div class="alert alert-danger" *ngIf="pesticidesAllowedAfterDays.errors?.required">
          Number of days is required
        </div>
      </div>
    </div>
  </div>
</div>

<app-vertical-tab-group>
  <app-vertical-tab *ngFor="let treatment of treatments.controls"
    [title]="'Treatment ' + treatment.value.treatmentNumber"
    [hasError]="treatment.get('plantHandlingInstructions').invalid">
    <div>
      <app-plant-handling-instructions-form [treatment]="treatment" [options]="plantHandlingOptions"
        #plantHandlingForm></app-plant-handling-instructions-form>
    </div>

    <div class="text-right">
      <button class="btn btn-default" type="button" (click)="applyAll(plantHandlingForm)">
        Apply to All
      </button>
    </div>
  </app-vertical-tab>
</app-vertical-tab-group>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions.component.html